export const SEAT_COUNT = 48
export const SEATS_PER_FLOOR = 16

// フロア内の席を、窓側から店内全体に散らばる順で並べたもの
const WITHIN_FLOOR = [5, 10, 1, 14, 7, 2, 12, 9, 0, 15, 4, 11, 6, 3, 13, 8]
const FLOOR_ORDER = [1, 0, 2]

/** 人が増えたときに3フロアへ交互に散らばる席の割り当て順 */
export const SEAT_ORDER: readonly number[] = Array.from({ length: SEATS_PER_FLOOR }, (_, k) =>
  FLOOR_ORDER.map((f) => f * SEATS_PER_FLOOR + WITHIN_FLOOR[(k + f * 5) % SEATS_PER_FLOOR]),
).flat()

export function assignSeat(occupied: ReadonlySet<number>): number | null {
  for (const s of SEAT_ORDER) if (!occupied.has(s)) return s
  return null
}
